import { ApplicationController } from './application_controller.js'
import axios from 'axios'
import setAxiosHeaders from '../components/AxiosHeaders'
import TomSelect from 'tom-select'
const COUNTRY_FROM_IP =
  document.querySelector("meta[name='country']").getAttribute('content') || 'US'

export default class extends ApplicationController {
  static values = {
    markerLatitude: Number,
    markerLongitude: Number,
    mapCenterLatitude: Number,
    mapCenterLongitude: Number,
    name: String,
    venueId: Number,
    mapId: String,
  }
  static targets = [
    'map',
    'latitude',
    'longitude',
    'autofill',
    'city',
    'street',
    'state',
    'postal',
    'search',
    'place',
    'name',
    'longName',
    'subvenues',
  ]

  enableEntry(event) {
    event.preventDefault()
    this.autofillTargets.forEach((target) => (target.disabled = false))
  }

  get formPopulated() {
    return (
      !!(this.venueIdValue > 0) ||
      !!(this.hasNameTarget && this.nameTarget.value)
    )
  }

  async connect() {
    setAxiosHeaders()
    console.log('venue-input connected', window.google)
    console.log('latitudeTargets', this.latitudeTargets)
    if (!this.formPopulated) {
      this.autofillTargets.forEach((target) => (target.disabled = true))
    }

    await window.mapsApiLoaded;

    if (!window.google) {
      return
    }

    this.google = window.google;

    try {
      const { Map } = await this.google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await this.google.maps.importLibrary("marker");
      const { PlaceAutocompleteElement } = await this.google.maps.importLibrary("places");

      this.Map = Map;
      this.AdvancedMarkerElement = AdvancedMarkerElement;
      this.Autocomplete = PlaceAutocompleteElement;
    } catch (e) {
      console.error("Failed to load Google Maps libraries", e);
      return;
    }

    console.log('venue-input google libraries loaded');

    if (this.hasSearchTarget) {
      const autocompleteEl = new this.Autocomplete({
        includedRegionCodes: [COUNTRY_FROM_IP]
      });

      if (Math.abs(Math.floor(this.mapCenterLatitudeValue)) > 0) {
        autocompleteEl.locationBias = {
          north: this.mapCenterLatitudeValue + 0.5,
          south: this.mapCenterLatitudeValue - 0.5,
          east: this.mapCenterLongitudeValue + 0.5,
          west: this.mapCenterLongitudeValue - 0.5
        }
      }
      // console.log('autocomplete with opts', options)

      autocompleteEl.fields = [
        'addressComponents',
        'internationalPhoneNumber',
        'location',
        'id',
        'websiteURI',
        'displayName',
        'types',
        'formattedAddress'
      ];

      autocompleteEl.Dg?.setAttribute('placeholder', 'Search for Location');

      this.searchTarget.appendChild(autocompleteEl);

      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      autocompleteEl.addEventListener('gmp-select', async ({ placePrediction }) => {
        console.log('place changed')
        const place = placePrediction.toPlace();
        await place.fetchFields({
          fields: autocompleteEl.fields
        });
        this.setPlace(place);
        // const pick = autocomplete.getPlace()
        // console.log('place: ', pick)
        // this.setPlace(pick)
      })
    }
    this.subvenuesTargets.forEach((target) => {
      new TomSelect(target, {
        persist: false,
        createOnBlur: true,
        create: true,
        plugins: {
          remove_button: {
            title: 'Remove this sub-venue',
          }
        }
      });
    })
    if (this.hasMapTarget && this.mapCenter) {
      this.map = new this.Map(this.mapTarget, {
        zoom: 13,
        center: this.mapCenter,
        mapTypeId: this.google.maps.MapTypeId.ROADMAP,
        mapId: this.mapIdValue
      })
      if (this.markerLatitudeValue) {
        this.marker = new this.AdvancedMarkerElement({
          position: this.mapCenter,
          map: this.map,
          title: this.nameValue
        })
        this.marker.gmpDraggable = true;
        this.marker.addListener('dragend', () =>
          this.markerMoved(true)
        )
      }
      axios
        .get('/venues.json')
        .then((response) => {
          const filtered = response.data.filter(
            (venue) =>
              venue.latitude && venue.longitude && venue.id != this.venueIdValue
          )
          filtered.forEach((venue, i) => {
            const location = new this.google.maps.LatLng(
              venue.latitude,
              venue.longitude
            );
            const markerIcon = document.createElement('img');
            markerIcon.src = "https://maps.google.com/mapfiles/marker_grey.png";
            new this.AdvancedMarkerElement({
              position: location,
              map: this.map,
              title: venue.name,
              content: markerIcon
            });
          })
        })
        .catch((e) => console.log('venue fetch error', e))
    }
  }

  get mapCenter() {
    if (this.markerLatitudeValue) {
      return new this.google.maps.LatLng(
        this.markerLatitudeValue,
        this.markerLongitudeValue
      )
    } else if (this.mapCenterLatitudeValue) {
      console.log('mapCenter from center values', this.mapCenterLatitudeValue, this.mapCenterLongitudeValue);
      return new this.google.maps.LatLng(
        this.mapCenterLatitudeValue,
        this.mapCenterLongitudeValue
      )
    }
  }

  markerMoved(dragged) {
    console.log('markerMoved!', this.latitudeTargets, this.longitudeTargets)

    this.latitudeTargets.forEach(
      (item, i) => (item.value = this.marker.position.lat)
    )
    this.longitudeTargets.forEach(
      (item, i) => (item.value = this.marker.position.lng)
    )
    if (dragged) {
      this.pinDropped = true
    }
  }

  setPlace(place) {
    this.autofillTargets.forEach((target) => (target.disabled = false));
    const { addressComponents, location, id, internationalPhoneNumber, displayName } = place;
    // console.log(addressComponents);
    const street_number = addressComponents.find((comp) =>
      comp.types.includes('street_number')
    )
    const street = addressComponents.find((comp) =>
      comp.types.includes('route')
    )
    const locality = addressComponents.find((comp) =>
      comp.types.includes('locality')
    )

    const sublocality = addressComponents.find((comp) =>
      comp.types.includes('sublocality')
    )
    const state = addressComponents.find((comp) =>
      comp.types.includes('administrative_area_level_1')
    )
    const postal = addressComponents.find((comp) =>
      comp.types.includes('postal_code')
    )
    const latitude = location.lat();
    const longitude = location.lng();
    this.streetTargets.forEach((target) => {
      if (street_number) {
        target.value = `${street_number.shortText} ${street.shortText}`
      }
    })
    this.cityTargets.forEach((target) =>
      this.setValueFromShortName(target, (locality || sublocality))
    )
    this.stateTargets.forEach((target) =>
      this.setValueFromShortName(target, state)
    )
    this.postalTargets.forEach((target) =>
      this.setValueFromShortName(target, postal)
    )
    this.latitudeTargets.forEach((target) => (target.value = latitude))
    this.longitudeTargets.forEach((target) => (target.value = longitude))
    this.nameTargets.forEach((target) => (target.value = displayName))
    this.longNameTargets.forEach((target) => target.value = [sublocality?.shortText, locality?.shortText, state?.shortText].filter((a) => a).join(", "))
    this.placeTargets.forEach((target) => (target.value = id))
    const newLocation = new this.google.maps.LatLng(latitude, longitude);

    if (this.marker) {
      console.log('marker found')
      this.marker.position = newLocation;
    } else {
      console.log('marker created')
      this.marker = new this.AdvancedMarkerElement({
        position: newLocation,
        map: this.map,
        title: this.name,
      });
      this.marker.gmpDraggable = true;
      this.marker.addListener('dragend', () =>
        this.markerMoved(true)
      )
    }
    this.map.setCenter(newLocation)
  }

  setValueFromShortName(target, value) {
    try {
      target.value = value.shortText
    } catch (error) {
      console.log('error', error)
    }
  }
}
